import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const ClientProjectContext = createContext({
  projects: [],
  projectId: "__all",
  setProjectId: () => {},
});

const STORAGE_KEY = "ubbs_client_active_project_id";

export function ClientProjectProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [projectId, _setProjectId] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "__all";
  });

  const setProjectId = useCallback((v) => {
    _setProjectId(v);
    if (v && v !== "__all") localStorage.setItem(STORAGE_KEY, v);
    else localStorage.removeItem(STORAGE_KEY);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/client/projects");
      setProjects(r.data);
      const ids = new Set(r.data.map((p) => p.id));
      if (projectId !== "__all" && !ids.has(projectId)) setProjectId("__all");
    } catch {
      /* swallow */
    }
  }, [projectId, setProjectId]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ClientProjectContext.Provider value={{ projects, projectId, setProjectId }}>
      {children}
    </ClientProjectContext.Provider>
  );
}

export const useClientProject = () => useContext(ClientProjectContext);
